const RELOAD_STORAGE_KEY = '@NeerHouse:lastPreloadErrorReload';
const RELOAD_COOLDOWN_MS = 10_000;

export const isDynamicImportFailure = (value: unknown): boolean => {
    let message = '';

    if (value instanceof Error) {
        message = value.message;
    } else if (typeof value === 'string') {
        message = value;
    } else if (
        value &&
        typeof value === 'object' &&
        'message' in value &&
        typeof (value as { message?: unknown }).message === 'string'
    ) {
        message = (value as { message: string }).message;
    }

    if (!message) return false;

    return [
        'Failed to fetch dynamically imported module',
        'Importing a module script failed',
        'ChunkLoadError',
        'Loading chunk',
        'Expected a JavaScript-or-Wasm module script',
        "Cannot use 'in' operator to search for 'default' in",
    ].some((pattern) => message.includes(pattern));
};

export const reloadOnceWithCacheBuster = (event?: Event) => {
    try {
        const lastReloadAt = Number(
            sessionStorage.getItem(RELOAD_STORAGE_KEY) || 0,
        );
        const canReload = Date.now() - lastReloadAt > RELOAD_COOLDOWN_MS;

        if (!canReload) return false;

        sessionStorage.setItem(RELOAD_STORAGE_KEY, String(Date.now()));
        event?.preventDefault();

        const url = new URL(window.location.href);
        url.searchParams.set('__v', String(Date.now()));
        window.location.replace(url.toString());

        return true;
    } catch {
        return false;
    }
};
